import '../scss/style.scss'; // Sassファイルを読み込む場合
import '../scss/acf/index.scss'; // Sassファイルを読み込む場合


// index.js
import './slider.js';
import './job-tabs.js';


document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(".p-page-content__section");
    const links = document.querySelectorAll(".p-page-content__nav-link");

    // Intersection Observerのオプション設定
    const observerOptions = {
        root: null, // ビューポートをルートに
        rootMargin: "0px",
        threshold: 0.3, // 30%が見える範囲
    };

    // Intersection Observerのコールバック関数
    const observerCallback = (entries) => {
        entries.forEach((entry) => {
            const targetId = entry.target.getAttribute("id");
            const relatedLink = document.querySelector(
                `.p-page-content__nav-link[href="#${targetId}"]`
            );

            if (entry.isIntersecting) {
                // 30%が可視範囲に入ったらactiveを追加
                links.forEach((link) => link.classList.remove("active"));
                relatedLink.classList.add("active");
            }
        });
    };

    // Intersection Observerを初期化
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // 各セクションにオブザーバーを設定
    sections.forEach((section) => observer.observe(section));

    // ############################################################
    // スラッグテキストのアニメーション
    // ############################################################
    const background = document.querySelector('.p-page-header__background');
    const slugContainer = document.querySelector('.p-page-header__slug-container');

    if (background && slugContainer) {
        // コンテナの幅を取得
        const containerWidth = background.offsetWidth;

        // 移動速度の設定（大きいほど速く移動）
        const moveSpeed = .5;

        // アニメーションのID保持用
        let animationFrameId = null;

        // アニメーションを開始
        function animate(currentPosition = 0) {
            const newPosition = currentPosition - moveSpeed;
            slugContainer.style.transform = `translateX(${newPosition}px)`;

            if (-newPosition > slugContainer.offsetWidth) {
                slugContainer.style.transform = `translateX(${containerWidth}px)`;
                setTimeout(() => {
                    animationFrameId = requestAnimationFrame(() => animate(containerWidth));
                }, 0);
            } else {
                animationFrameId = requestAnimationFrame(() => animate(newPosition));
            }
        }

        // Intersection Observer の設定
        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // 要素が表示範囲内に入った時
                    slugContainer.style.transform = `translateX(-50%)`;
                    slugContainer.style.animation = `none`;
                    animate();
                } else {
                    // 要素が表示範囲外に出た時
                    if (animationFrameId) {
                        cancelAnimationFrame(animationFrameId);
                        animationFrameId = null;
                    }
                }
            });
        }, observerOptions);

        // 監視開始
        observer.observe(background);
    }
});

// // サイドバーの固定
// const initStickyElements = () => {
//     const sidebarElement = document.querySelector('.p-page-content__sidebar');
//     const headerElement = document.querySelector('.site-layout__t');

//     if (!sidebarElement && !headerElement) {
//         return; // 要素が存在しない場合は処理を終了
//     }

//     let lastScrollTop = 0;
//     let ticking = false;

//     const updateSticky = () => {
//         if (sidebarElement) {
//             const sidebarTop = sidebarElement.getBoundingClientRect().top;
//             if (sidebarTop < 0) {
//                 sidebarElement.style.top = `${Math.abs(sidebarTop)}px`;
//             } else {
//                 sidebarElement.style.top = '0';
//             }
//         }

//         if (headerElement) {
//             const scrollTop = window.pageYOffset;
//             if (scrollTop > lastScrollTop) {
//                 headerElement.style.transform = 'translateY(-100%)';
//             } else {
//                 headerElement.style.transform = 'translateY(0)';
//             }
//             lastScrollTop = scrollTop;
//         }

//         ticking = false;
//     };

//     window.addEventListener('scroll', () => {
//         if (!ticking) {
//             window.requestAnimationFrame(updateSticky);
//             ticking = true;
//         }
//     });
// };

// document.addEventListener('DOMContentLoaded', () => {
//     initStickyElements();
// });


// スムーススクロール
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
            event.preventDefault();

            const targetSelector = anchor.getAttribute('href');
            const targetElement = document.querySelector(targetSelector);

            if (!targetElement) {
                return;
            }

            // オフセット要素の高さを取得
            const offsetElement = document.querySelector('.site-layout__t');
            const offset = offsetElement ? offsetElement.offsetHeight + 32 : 32;

            // スクロール位置の計算
            const rect = targetElement.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = rect.top + scrollTop - offset;

            // スムーススクロールを実行
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        });
    });
});

// フォームの戻るボタンの処理
document.addEventListener('DOMContentLoaded', function () {
    const previousButtons = document.querySelectorAll('.wpcf7-previous');

    previousButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            window.history.back();
        });
    });
});

// ハンバーガーメニューの制御
const initHamburgerMenu = () => {
    const hamburger = document.querySelector('.c-hamburger');
    const spNav = document.querySelector('.p-header__nav');
    const body = document.body;

    if (!hamburger || !spNav) return;

    hamburger.addEventListener('click', () => {
        if (spNav.classList.contains('is-active')) {
            // メニューを閉じる処理
            spNav.classList.add('is-remove');
            hamburger.classList.remove('is-active');
            body.classList.remove('is-fixed');

            // アニメーション完了後にクラスを削除
            setTimeout(() => {
                spNav.classList.remove('is-active');
                spNav.classList.remove('is-remove');
            }, 300); // CSSのトランジション時間と合わせる
        } else {
            // メニューを開く処理
            spNav.classList.add('is-active');
            hamburger.classList.add('is-active');
            body.classList.add('is-fixed');
        }
    });

    // メニューリンクをクリックしたらメニューを閉じる
    const menuLinks = spNav.querySelectorAll('a');
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            spNav.classList.add('is-remove');
            hamburger.classList.remove('is-active');
            body.classList.remove('is-fixed');

            setTimeout(() => {
                spNav.classList.remove('is-active');
                spNav.classList.remove('is-remove');
            }, 300);
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    initHamburgerMenu();
});
